export default function Loader() {
	return (
		<div className='Loader'>
			<span>Загрузка...</span>
		</div>
	)
}
